import { useState } from "react";
import { toast } from "react-toastify";
import {
  createBlockedUsers,
  getTransactionByField,
  addBlockKeyword,
} from "../../config/LiveApi";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";

const BlockFraudUsers = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    vpa: "",
    ifsc: "",
    accountNumber: "",
  });
  const [loading, setLoading] = useState(false);
  const token = useSelector((store) => store.userReducer.token);

  const [searchType, setSearchType] = useState("responseUTR");
  const [searchId, setSearchId] = useState("");
  const [txnList, setTxnList] = useState([]);
  const [txnLoading, setTxnLoading] = useState(false);
  const [keyword, setKeyword] = useState("");

  // FETCH TXN
  const fetchTxn = async () => {
    if (!searchId.trim()) {
      toast.error("Enter UTR / Order Id");
      return;
    }

    setTxnLoading(true);

    try {
      const ids = searchId.split(",").map((id) => id.trim());

      const results = await Promise.all(
        ids.map((id) => getTransactionByField(token, searchType, id)),
      );

      const flatData = results.flat();

      const parsed = flatData.map((data) => {
        let requestData = {};
        let responseData = {};

        requestData = data?.request ? JSON.parse(data.request) : {};
        responseData = data?.resposne ? JSON.parse(data.resposne) : {};

        return {
          raw: data,
          userId: data?.userId,
          name: requestData?.customerName || "",
          email: requestData?.customerEmail || "",
          phoneNumber: requestData?.customerMobile || "",
          vpa: responseData?.vpa || requestData?.vpa || "",
          ifsc: responseData?.ifsc || "",
          accountNumber: responseData?.accountNo || "",
        };
      });

      setTxnList(parsed);
      toast.success(`Fetched ${parsed.length} transactions`);
    } catch (err) {
      toast.error("Failed to fetch");
    } finally {
      setTxnLoading(false);
    }
  };

  // BLOCK
  const handleSubmit = async () => {
    if (!txnList.length) {
      toast.error("No data to block");
      return;
    }

    setLoading(true);

    let success = 0;
    let failed = 0;
    let duplicate = 0;

    const chunkSize = 20;

    for (let i = 0; i < txnList.length; i += chunkSize) {
      const chunk = txnList.slice(i, i + chunkSize);

      await Promise.all(
        chunk.map(async (txn) => {
          const payload = {
            userId: txn.userId,
            name: txn.name,
            email: txn.email,
            phoneNumber: txn.phoneNumber,
            vpa: txn.vpa,
            ifsc: txn?.ifsc,
            accountNumber: txn?.accountNumber,
          };

          try {
            await createBlockedUsers(payload);
            success++;
          } catch (err) {
            if (err?.response?.status === 409) {
              duplicate++;
            } else {
              failed++;
            }
          }
        }),
      );
    }

    toast.success(
      `Blocked: ${success} | Already Blocked: ${duplicate} | Failed: ${failed}`,
    );
    setTxnList([]);
    setSearchId("");
    setLoading(false);
  };
  // BLOCK KEYWORD
  const handleKeywordSubmit = async (e) => {
    e.preventDefault();

    if (!keyword.trim()) {
      toast.error("Keyword is required.");
      return;
    }

    try {
      setLoading(true);

      await addBlockKeyword(keyword.trim());

      toast.success("Keyword added successfully.");

      setKeyword(""); // clear input
    } catch (error) {
      console.error("Error adding Keyword:", error);
      toast.error(error?.response?.data?.message || "Failed to add Keyword.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={container}>
      <h2 style={title}>Block Fraud Users</h2>

      {/* UTR / ORDER SEARCH */}
      <div style={box}>
        <h3>Fetch Data From Transaction</h3>

        <div style={row}>
          <ReactSelect
            options={[
              { value: "requestOrderId", label: "Order Id" },
              { value: "responseUTR", label: "UTR" },
            ]}
            value={{
              value: searchType,
              label: searchType === "responseUTR" ? "UTR" : "Order Id",
            }}
            onChange={(opt) => setSearchType(opt.value)}
            styles={{ container: (base) => ({ ...base, width: 200 }) }}
          />

          <input
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
            placeholder="Enter value"
            style={inputStyle}
          />

          <button onClick={fetchTxn} style={buttonStyle}>
            {txnLoading ? "Fetching..." : "Fetch"}
          </button>
        </div>

        {txnList.length > 0 && (
          <div style={previewBox}>
            {txnList.map((txn, i) => (
              <div
                key={i}
                style={{ marginBottom: 10, borderBottom: "1px solid #eee" }}
              >
                <p>
                  <b>Name:</b> {txn.name}
                </p>
                <p>
                  <b>Email:</b> {txn.email}
                </p>
                <p>
                  <b>Phone:</b> {txn.phoneNumber}
                </p>
                <p>
                  <b>VPA:</b> {txn.vpa}
                </p>
                <p>
                  <b>Ifsc:</b> {txn.ifsc}
                </p>
                <p>
                  <b>Account Number:</b> {txn.accountNumber}
                </p>
              </div>
            ))}
          </div>
        )}

        <button onClick={handleSubmit} disabled={loading} style={buttonStyle}>
          {loading ? "Blocking..." : "Block This User"}
        </button>
      </div>

      {/* MANUAL - block-keyword */}
      <div style={keywordBox}>
        <h3>Add New Keyword</h3>

        <form onSubmit={handleKeywordSubmit} style={formRow}>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="Enter new keyword"
            style={inputStyle}
          />

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? "Adding..." : "Add Keyword"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BlockFraudUsers;

// STYLES
const container = {
  padding: 24,
  maxWidth: 900,
  margin: "0 auto",
  display: "flex",
  flexDirection: "column",
  gap: 24,
};

const title = { fontSize: 20, fontWeight: 600 };

const box = {
  border: "1px solid #ddd",
  padding: 16,
  borderRadius: 8,
  display: "flex",
  flexDirection: "column",
  gap: 16,
};

const row = {
  display: "flex",
  gap: 12,
  alignItems: "center",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 12,
};

const inputStyle = {
  padding: 8,
  border: "1px solid #ccc",
  borderRadius: 6,
  flex: 1,
};

const buttonStyle = {
  backgroundColor: "#fc8019",
  color: "#fff",
  fontWeight: 700,
  padding: "10px 16px",
  borderRadius: 6,
  border: "none",
  cursor: "pointer",
};

const previewBox = {
  background: "#f9f9f9",
  padding: 12,
  borderRadius: 6,
};

const keywordBox = {
  border: "1px solid #ddd",
  padding: 16,
  borderRadius: 8,
  display: "flex",
  flexDirection: "column",
  gap: 12,
};

const formRow = {
  display: "flex",
  gap: 10,
};
